import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-75a62f7d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-input" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "ID", -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" IDを入力してください。 ")
const _hoisted_4 = { class: "form-input" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "パスワード", -1))
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" パスワードを入力してください。 ")
const _hoisted_7 = { class: "errMsg" }
const _hoisted_8 = { class: "form-input" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" ログイン ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppInput = _resolveComponent("AppInput")!
  const _component_TextAlert = _resolveComponent("TextAlert")!
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args)), ["prevent"])),
    class: "login-form"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode(_component_AppInput, {
        modelValue: _ctx.form.userId,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.userId) = $event)),
        label: "ID",
        type: 'text',
        inputId: 'form-userId',
        onBlur: _cache[1] || (_cache[1] = ($event: any) => (_ctx.blurCheck('userId')))
      }, null, 8, ["modelValue"]),
      (_ctx.userIdErrFlag)
        ? (_openBlock(), _createBlock(_component_TextAlert, {
            key: 0,
            class: _normalizeClass('errMsg-id')
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createVNode(_component_AppInput, {
        modelValue: _ctx.form.password,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.password) = $event)),
        label: "パスワード",
        type: 'password',
        inputId: 'form-password',
        onBlur: _cache[3] || (_cache[3] = ($event: any) => (_ctx.blurCheck('password')))
      }, null, 8, ["modelValue"]),
      (_ctx.passwordErrFlag)
        ? (_openBlock(), _createBlock(_component_TextAlert, {
            key: 0,
            class: _normalizeClass('errMsg-password')
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.loginErrMsg), 1),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_AppButton, {
        styled: 'is-accent',
        type: 'submit',
        buttonId: 'button-login'
      }, {
        default: _withCtx(() => [
          _hoisted_9
        ]),
        _: 1
      })
    ])
  ], 32))
}